import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=635c2ce4&scoped=true"
import script from "./UpdateNotification.vue?vue&type=script&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=635c2ce4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c2ce4",
  null
  
)

export default component.exports